import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useSelector } from 'react-redux'
import cn from 'classnames'

import styles from './styles.module.scss'
import { getKioskBreaths } from '../../../../api'

import Dialog from '../index'
import Button from '../../Button/Button'

const KioskBreaths = ({open, handleClose, onRestore, title, companyId, kioskId}) => {
  const { t } = useTranslation()

  const companyInfo = useSelector((state) => state.company.companyInfo)

  const [breaths, setBreaths] = useState([])

  useEffect(() => {
    if (companyId && kioskId) {
      getKioskBreaths(companyId, kioskId).then((res) => {
        if (Array.isArray(res)) {
          setBreaths(res)
        }
      })
    }
  }, [companyId, kioskId])

  const handleRestore = () => {
    onRestore(companyId, kioskId)
  }

  return (
    <Dialog
      handleClose={handleClose}
      open={open}
      title={title}>
      <div className={styles.breathsDialog}>
        <div className={styles.title}>
          { t('Current breaths count') }
        </div>
        <div className={styles.count}>
          {breaths.length}
        </div>
        <div className={styles.subTitle}>
          { t('Breaths restore history') }
        </div>
        <div className={styles.breathsContainer}>
          {
            breaths.map((breath) => {
              const [resultValue, resultStatus] = breath.result.split('-')
              return (
                <div key={breath.id} className={styles.breathItem}>
                  <div>{moment(breath.created_at).format(companyInfo.date_format)}</div>
                  <div>{breath.employee_name} {breath.employee_surname}</div>
                  <div className={cn(styles.breathResult, {[styles.failed]: resultStatus !== 'OK', [styles.success]: resultStatus === 'OK'})}>{resultStatus === 'OK' ? resultStatus : resultValue}</div>
                </div>
              )
            })
          }
        </div>
        <div className={styles.buttonSaveBlock}>
          <Button
            onClick={handleRestore}
            fillWidth
            size='big'
          >
            {t('Restore')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default KioskBreaths
